import { ReactComponent as CompressIcon } from 'assets/icons/fa-compress.svg';
import { ReactComponent as ExpandIcon } from 'assets/icons/fa-expand.svg';
import { ReactComponent as MapLocationDotIcon } from 'assets/icons/fa-map-location-dot.svg';

import { ReactComponent as HelpIcon } from 'assets/icons/fa-question.svg';
import { ReactComponent as VolumeOnIcon } from 'assets/icons/fa-volume-high.svg';
import { ReactComponent as VolumeMuteIcon } from 'assets/icons/fa-volume-xmark.svg';
import { AutoPlayIcon } from 'components/icons';
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAutoPlay, setAutoRotate, toggleAudio } from 'store/actions';
import { canFullscreen, toggleFullScreen } from 'utils';
import MapFloorPlan from './MapFloorPlan';
import './mobiController.scss';

const MobiController = ({
  currentPano,
  isShowMapFloorPlan,
  floorMaps,
  selectSceneById,
  showLanding,
}) => {
  const [toggleMapFloorPlan, setToggleMapFloorPlan] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const { autoPlayMode } = useSelector((state) => state);

  const audio = useSelector((state) => state.audio);

  const dispatch = useDispatch();

  const handleToggleAudio = () => {
    dispatch(toggleAudio(!audio.enabled));
  };

  const handleToggleFloorPlan = useCallback(() => {
    setToggleMapFloorPlan((value) => !value);
  }, []);

  const handleFullScreen = () => {
    toggleFullScreen();
    setFullScreen(!fullScreen);
  };

  const handleToggleHelp = () => {
    showLanding();
  };

  const isHideMap = useMemo(() => {
    const getMap = currentPano?.hotspots.filter(
      (hotspot) => hotspot.type === 'Media'
    );
    return !!getMap?.find(
      (item) =>
        (!item.configs || JSON.parse(item.configs).isShowMapFloorPlan) &&
        item.media.type === 'MapFloorPlan'
    );
  }, [currentPano]);

  return (
    <div className="mobi-controller-container">
      <div className="controller-list">
        {isShowMapFloorPlan && !isHideMap && (
          <div
            className={`controller-list-item ${
              toggleMapFloorPlan ? 'mapOpen' : ''
            }`}
          >
            {!toggleMapFloorPlan && (
              <div className="controller-list-item-popover">
                <div className="popover-content">Sơ đồ khu vực</div>
              </div>
            )}

            <MapLocationDotIcon
              className="icon map-icon"
              onClick={handleToggleFloorPlan}
            />

            <MapFloorPlan
              toggleMapFloorPlan={toggleMapFloorPlan}
              handleToggleFloorPlan={handleToggleFloorPlan}
              currentPano={currentPano}
              floorMaps={floorMaps}
              selectSceneById={selectSceneById}
            />
          </div>
        )}

        {audio?.available && (
          <div className={`controller-list-item`} onClick={handleToggleAudio}>
            <div className="controller-list-item-popover">
              <div className="popover-content">Bật tắt âm thanh</div>
            </div>
            {audio?.enabled ? (
              <VolumeOnIcon className="icon" />
            ) : (
              <VolumeMuteIcon className="icon" />
            )}
          </div>
        )}

        {canFullscreen() && (
          <div className={`controller-list-item`} onClick={handleFullScreen}>
            <div className="controller-list-item-popover">
              <div className="popover-content">Bật tắt xem toàn màn hình</div>
            </div>
            {!fullScreen ? (
              <ExpandIcon className="icon" />
            ) : (
              <CompressIcon className="icon" />
            )}
          </div>
        )}

        {/* <div className={`controller-list-item`}>
          <div className="controller-list-item-popover">
            <div className="popover-content">Liên hệ</div>
          </div>
          <ExternalLink />
        </div> */}

        <div className={`controller-list-item`} onClick={handleToggleHelp}>
          <div className="controller-list-item-popover">
            <div className="popover-content">Hướng dẫn</div>
          </div>
          <HelpIcon className="icon" />
        </div>

        <div
          className={`controller-list-item`}
          onClick={() => {
            dispatch(setAutoPlay(!autoPlayMode));

            if (
              currentPano?._id !== '6751672d97d14bbd943b570c' &&
              currentPano?._id !== '6751675497d14bbd943b5730'
            ) {
              setTimeout(() => {
                dispatch(setAutoRotate(true));
              }, 1000);
            }
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '47px',
          }}
        >
          <div className="controller-list-item-popover">
            <div className="popover-content">Tự động chuyển cảnh</div>
          </div>
          <AutoPlayIcon shouldRotate={autoPlayMode} />
        </div>
      </div>
    </div>
  );
};

export default MobiController;
